import {FaSolidTriangleExclamation} from "solid-icons/fa";
import css from "./error.module.css"
import {Show} from "solid-js";
import {A} from "@solidjs/router";
import {Button} from "../ui/Button";
import {isDev} from "solid-js/web";

export default function Error(props: { err: any, reset: () => void, hideHome?: boolean }) {

    if (isDev) console.error(props.err)

    return (
        <>
            <div class={css.title}>
                <FaSolidTriangleExclamation/>
                <span>Unexpected Error</span>
            </div>
            <div class={css.message}>
                <Show when={props.err.name === "ApiError" || isDev} fallback={<span>Internal Server Error</span>}>
                    <p>{props.err.message}{isDev && props.err.name === "ApiError" ? String(props.err.err) : ""}</p>
                </Show>
            </div>
            <div class={css.actions}>
                <Show when={!props.hideHome}>
                    <A href="/">Home</A>
                </Show>
                <Button variant={"primarySolid"} onClick={props.reset}>Try again</Button>
            </div>
        </>
    )
}